import { rgba } from 'polished';
import styled, { css } from 'styled-components';

export const Box = styled.span<{ $checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 1.4rem;
  height: 1.4rem;
  margin: ${({ theme }) => theme.spacing(0.75)};
  border-radius: ${({ theme }) => theme.spacing(1.25)};

  font-size: 1rem;
  line-height: 62.5%;

  ${({ theme, $checked }) =>
    $checked
      ? css`
          background: #818cf8;
          color: ${theme.palette.common.white};
        `
      : css`
          border: 1.5px solid ${rgba(theme.palette.common.white, 0.4)};
        `};
`;
